export enum RoutesHome {
  HOME = 'home',
}
